module.exports = __webpack_public_path__ + "img/system13-mini.297e8592.png";